<swiper-container #swiper init="false">
  <ng-container *ngFor="let districtKey of getDistrictKeys()">
    <swiper-slide 
      class="slide-{{ districtKey | slugify }}"
      *ngIf="shops[districtMap[districtKey].id]?.length"
    >
      <div class="district-name">
        <span>
          <span [ngStyle]="{'color': districtMap[districtKey].color}">{{ districtKey }}</span> District
        </span>
      </div>
      
      <div 
        class="tap"
        *ngFor="let shop of shops[districtMap[districtKey].id]"
        [ngStyle]="{'top.em': shop.top, 'left.em': shop.left}"
        (click)="onNavigateToShop(shop.id)"
      >
        <div class="tap-wrap">
          <ng-container *ngIf="shop.yieldStatus !== 'neutral' && shop.active">
            <div class="yield-text">KPI's</div>
            <div class="yield-arrow">
              <img *ngIf="shop.yieldStatus === 'positive'" src="/assets/img/game/yield-arrow-up.svg">
              <img *ngIf="shop.yieldStatus === 'negative'" src="/assets/img/game/yield-arrow-down.svg">
            </div>
          </ng-container>
          <ng-container *ngIf="shop.active">
            <img src="/assets/img/game/tap-pink.svg" class="tap-bg" *ngIf="shop.type === 'Existing Retailer'">
            <img src="/assets/img/game/tap-green.svg" class="tap-bg" *ngIf="shop.type === 'New Prospect'">
          </ng-container>
          <img src="/assets/img/game/tap-gray.svg" class="tap-bg" *ngIf="!shop.active">
          <div class="shop-descr-wrap">
            <div class="title">{{ shop.name }}</div>
            <div class="subtitle">TAP NOW TO VISIT</div>
          </div>
        </div>
      </div>
    </swiper-slide>
  </ng-container>
</swiper-container>

<div class="arrow-wrap prev">
  <img *ngIf="currentDistrict > 0" class="rotated arrow" src="/assets/img/game/arrow-right.svg" (click)="prevDistrict()">
  <img *ngIf="currentDistrict <= 0" class="rotated arrow" src="/assets/img/game/arrow-right-disabled.svg">
</div>
<div class="arrow-wrap next">
  <img *ngIf="currentDistrict < getDistrictKeys().length - 1" class="arrow" src="/assets/img/game/arrow-right.svg" (click)="nextDistrict()">
  <img *ngIf="currentDistrict >= getDistrictKeys().length - 1" class="arrow" src="/assets/img/game/arrow-right-disabled.svg">
</div>

<div class="back-button">
  <img src="/assets/img/game/back-button.svg" (click)="onBackClick()">
  <div>Back to main map</div>
</div>

<img class="pmi-logo" src="/assets/img/game/pmi-logo.svg">
<img class="swipable" src="/assets/img/game/swipable-white.svg">